import { render, staticRenderFns } from "./EditMailboxModal.vue?vue&type=template&id=44505e04&scoped=true"
import script from "./EditMailboxModal.vue?vue&type=script&lang=js"
export * from "./EditMailboxModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44505e04",
  null
  
)

export default component.exports